import { h } from 'preact'
import Icon from '../../preact-components/assets'

interface Props {
  label: string
  url: string
  isExternalLinkForToggle?: boolean
}
export const ExternalLink = ({ label, url, isExternalLinkForToggle = true }: Props) => {
  const labelClassName = isExternalLinkForToggle ? 'how-to-link-for-toggle' : 'how-to-link-for-block'
  return (
    <div className='how-to-with-icon'>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={url} target='_blank'>
        <span className={labelClassName}> {label}</span>
        <Icon customClass='icon-open-in-new' icon='openInNew' width={12} height={12} />
      </a>
    </div>
  )
}
